import React, { useMemo, useState } from 'react';
import './itemActions.css';

interface AddProductNotePopupProps {
    onClose: () => void;
    onNoteSubmit: (note: string) => void;
    existingNote: string | undefined;
}

const QUICK_NOTES = ['No onions', 'Well done', 'On the side', 'Extra hot', 'Allergy — nuts', 'Gluten free', 'No ice', 'To share'];

const AddProductNotePopup: React.FC<AddProductNotePopupProps> = ({ onClose, onNoteSubmit, existingNote }) => {
    const [note, setNote] = useState<string>(existingNote || '');

    const activeQuick = useMemo(() => new Set(note.split(',').map((s) => s.trim())), [note]);
    const toggleQuick = (q: string) => {
        setNote((prev) => {
            const parts = prev.split(',').map((s) => s.trim()).filter(Boolean);
            return parts.includes(q) ? parts.filter((p) => p !== q).join(', ') : [...parts, q].join(', ');
        });
    };

    return (
        <div className="tia-card">
            <div className="tia-mhead">
                <div>
                    <div className="tia-mtitle">{existingNote ? 'Edit note' : 'Add a note'}</div>
                    <div className="tia-msub">The kitchen sees this on the ticket</div>
                </div>
                <button className="tia-x" onClick={onClose} aria-label="Close">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M13 1L1 13M1 1L13 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </button>
            </div>
            <div className="tia-mbody">
                <div className="tia-chips">
                    {QUICK_NOTES.map((q) => (
                        <button key={q} className={`tia-chip2${activeQuick.has(q) ? ' is-on' : ''}`} onClick={() => toggleQuick(q)}>
                            {activeQuick.has(q) && <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>}
                            {q}
                        </button>
                    ))}
                </div>
                <textarea
                    className="tia-textarea"
                    autoFocus
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    rows={3}
                    placeholder="Type a note for the kitchen…"
                />
                <div className="tia-hint">Tap a quick note above, or type your own.</div>
            </div>
            <div className="tia-mfoot">
                {note ? <button className="tia-btn tia-btn--ghostdanger" onClick={() => setNote('')}>Clear</button> : <span />}
                <div className="tia-footright">
                    <button className="tia-btn tia-btn--ghost" onClick={onClose}>Cancel</button>
                    <button className="tia-btn tia-btn--primary" onClick={() => onNoteSubmit(note)}>Save note</button>
                </div>
            </div>
        </div>
    );
};

export default AddProductNotePopup;
